export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["Custom"] = 1] = "Custom";
    ActivityType[ActivityType["AvatarUpdated"] = 2] = "AvatarUpdated";
    ActivityType[ActivityType["ClubCreated"] = 3] = "ClubCreated";
    ActivityType[ActivityType["EventPublished"] = 6] = "EventPublished";
    ActivityType[ActivityType["EventCanceled"] = 7] = "EventCanceled";
    ActivityType[ActivityType["ParticipationClassCanceled"] = 8] = "ParticipationClassCanceled";
    ActivityType[ActivityType["ParticipationCreated"] = 9] = "ParticipationCreated";
    ActivityType[ActivityType["ParticipationRanked"] = 10] = "ParticipationRanked";
    ActivityType[ActivityType["NewsPublished"] = 11] = "NewsPublished";
    ActivityType[ActivityType["TipOfTheDay"] = 12] = "TipOfTheDay";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=ActivityType.js.map